import { Check } from "lucide-react";
import { Eyebrow, Reveal } from "../components/Reveal";
import { DashboardMock } from "../components/DashboardMock";

const POINTS = [
  "Centralizado: nada se perde em conversas soltas",
  "Rastreável: cada etapa registrada e visível",
  "Transparente: todos sabem onde a demanda está",
];

export const Technology = () => (
  <section
    id="tecnologia"
    className="relative overflow-hidden bg-petrol py-24 lg:py-32"
    data-testid="technology-section"
  >
    <div className="glow-brand-strong pointer-events-none absolute -top-40 left-1/3 h-[500px] w-[500px] rounded-full" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid items-end gap-10 lg:grid-cols-[1fr_auto]">
        <Reveal>
          <Eyebrow dark>Tecnologia Resolv</Eyebrow>
          <h2 className="mt-4 max-w-xl font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Tudo organizado <span className="text-brand-400">em um só lugar.</span>
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/60">
            A Resolv transforma demandas que normalmente acontecem por WhatsApp, telefone e
            planilhas em um processo organizado, rastreável e transparente.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <ul className="space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-center gap-3 text-sm text-white/75">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-brand/20 text-brand-400">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                </span>
                {p}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>

      <Reveal delay={0.1} className="mt-14">
        <DashboardMock />
      </Reveal>

      <p className="mt-6 text-center font-mono text-[0.65rem] uppercase tracking-[0.22em] text-white/30">
        Interface ilustrativa da plataforma Resolv
      </p>
    </div>
  </section>
);
